import { render, staticRenderFns } from "./corporateTrainingHero.vue?vue&type=template&id=bd0fa0c2&"
import script from "./corporateTrainingHero.vue?vue&type=script&lang=js&"
export * from "./corporateTrainingHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports